import { gql } from "graphql-request";

const TEMPLATE_PROPS_FRAGMENT = gql`
  fragment TemplatePropsFragment on Template {
    id
    createdBy
    createdAt
    updatedAt
    updatedBy
    description
    title
    thumbnailImageUrl
    thumbnailImage
    solver
    editable
    creator
    timeSinceCreated
  }
`;
const TEMPLATE_DETAILS_PROPS_FRAGMENT = gql`
  fragment TemplateDetailsPropsFragment on TemplateDetails {
    id
    createdBy
    createdAt
    updatedAt
    updatedBy
    description
    title
    thumbnailImage
    access
    published
    inMarket    
    modelerDescription
    modelerTitle
    modelerThumbnailImage
    modelerAccess
    modelerId
    solver
    topics
    industries
  }
`;

const TEMPLATE_ITEMS_FRAGMENT = gql`
  fragment TemplateItemsFragment on TemplateDetails {
    parameterGroups {
      items {
        id
        name
        children {
          items {
            id
            name
            displayName
            type
            description
            defaultValue
            minValue
            maxValue
            step
            optionsList
          }
        }
      }
    }
  }
`;

const FOLDERS_FIELDS_FRAGMENT = gql`
  fragment FolderFields on FolderItem {
    id
    type
    name
    path
    file
  }
`;

const TEMPLATE_FOLDERS_FRAGMENT = gql`
  fragment TemplateFoldersFragment on TemplateDetails {
    folders {
      items {
        ...FolderFields
      }
    }
  }
  ${FOLDERS_FIELDS_FRAGMENT}
`;

export const GET_TEMPLATES_BY_FILTER_QUERY = gql`
  query getTemplatesListByFilter(
    $filter: TemplateFilterInput
    $from: Int
    $size: Int
    $context: RequestContextInput!
  ) {
    listTemplates(
      filter: $filter
      from: $from
      size: $size
      context: $context
    ) {
      items {
        ...TemplatePropsFragment
      }
      total
    }
  }
  ${TEMPLATE_PROPS_FRAGMENT}
`;

export const GET_TEMPLATE_BY_ID_QUERY = gql`
  query getTemplate($id: FirstLevelIDInput!, $context: RequestContextInput!) {
    getTemplate(id: $id, context: $context) {
      ...TemplateDetailsPropsFragment
      ...TemplateItemsFragment
      ...TemplateFoldersFragment
    }
  }
  ${TEMPLATE_DETAILS_PROPS_FRAGMENT}
  ${TEMPLATE_ITEMS_FRAGMENT}
  ${TEMPLATE_FOLDERS_FRAGMENT}
`;
export const CREATE_NEW_TEMPLATE_MUTATION = gql`
  mutation createTemplate(
    $input: CreateTemplateInput!
    $context: RequestContextInput!
  ) {
    createTemplate(input: $input, context: $context) {
      id
      createdBy
      description
      title
      thumbnailImage
      access
      published
      modelerTitle
      modelerDescription
      modelerAccess
      modelerThumbnailImage
    }
  }
`;
export const CLONE_TEMPLATE_MUTATION = gql`
  mutation cloneTemplate(
    $input: CloneTemplateInput!
    $context: RequestContextInput!
  ) {
    cloneTemplate(input: $input, context: $context){
      ...TemplateDetailsPropsFragment
    }
  }
  ${TEMPLATE_DETAILS_PROPS_FRAGMENT}
`;
export const PUBLISH_TEMPLATE_MUTATION = gql`
  mutation publishTemplate(
    $input: PublishTemplateInput!
    $context: RequestContextInput!
  ) {
    publishTemplate(input: $input, context: $context){
      id
      modelerId
      published
    }
  }
`;

export const UNPUBLISH_TEMPLATE_MUTATION = gql`
  mutation unpublishTemplate(
    $input: PublishTemplateInput!
    $context: RequestContextInput!
  ) {
    unpublishTemplate(input: $input, context: $context){
      id
      modelerId
      published
    }
  }
`;


export const UPDATE_TEMPLATE_MUTATION = gql`
  mutation updateTemplate(
    $input: UpdateTemplateInput!
    $condition: FirstLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateTemplate(input: $input, condition: $condition, context: $context) {
      ...TemplateDetailsPropsFragment
    }
  }
  ${TEMPLATE_DETAILS_PROPS_FRAGMENT}
`;
export const DELETE_TEMPLATE_MUTATION = gql`
  mutation deleteTemplate(
    $id: FirstLevelIDInput!
    $context: RequestContextInput!
  ) {
    deleteTemplate(input: $id, context: $context){
      id
    }
  }
`;

export const CREATE_PARAMETER_GROUP_MUTATION = gql`
  mutation createParameterGroup(
    $input: CreateParameterGroupInput!
    $context: RequestContextInput!
  ) {
    createParameterGroup(input: $input, context: $context) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PARAMETER_GROUP_MUTATION = gql`
  mutation updateParameterGroup(
    $input: UpdateParameterGroupInput!
    $condition: SecondLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateParameterGroup(
      input: $input
      condition: $condition
      context: $context
    ) {
      id
      name
    }
  }
`;

export const DELETE_PARAMETER_GROUP_MUTATION = gql`
  mutation deleteParameterGroup(
    $input: SecondLevelIDInput!
    $context: RequestContextInput!
  ) {
    deleteParameterGroup(input: $input, context: $context) {
      id
    }
  }
`;

export const CREATE_FOLDER_ITEM_MUTATION = gql`
  mutation createFolderItem(
    $folder: CreateFolderItemInput!
    $context: RequestContextInput!
  ) {
    createFolderItem(input: $folder, context: $context) {
      ...FolderFields
    }
  }
  ${FOLDERS_FIELDS_FRAGMENT}
`;

export const UPDATE_FOLDER_ITEM_MUTATION = gql`
  mutation updateFolderItem(
    $folder: UpdateFolderItemInput!
    $condition: SecondLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateFolderItem(input: $folder, condition: $condition, context: $context) {
      ...FolderFields
    }
  }
  ${FOLDERS_FIELDS_FRAGMENT}
`;

export const DELETE_FOLDER_ITEM_MUTATION = gql`
  mutation deleteFolderItem(
    $id: SecondLevelIDInput!
    $context: RequestContextInput!
  ) {
    deleteFolderItem(input: $id, context: $context) {
      id
    }
  }
`;

export const CREATE_PARAMETER_ITEM_MUTATION = gql`
  mutation createParameterItem(
    $input: CreateParameterItemInput!
    $context: RequestContextInput!
  ) {
    createParameterItem(input: $input, context: $context) {
      id
      minValue
      maxValue
      name
      optionsList
      step
      type
      updatedAt
      createdAt
      defaultValue
      description
      displayName
      groupId
      templateId
    }
  }
`;

export const UPDATE_PARAMETER_ITEM_MUTATION = gql`
  mutation updateParameterItem(
    $input: UpdateParameterItemInput!
    $condition: ThirdLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateParameterItem(
      input: $input
      condition: $condition
      context: $context
    ) {
      id
      minValue
      maxValue
      name
      optionsList
      step
      type
      updatedAt
      createdAt
      defaultValue
      description
      displayName
      groupId
    }
  }
`;

export const DELETE_PARAMETER_ITEM_MUTATION = gql`
  mutation deleteParameterItem(
    $id: ThirdLevelIDInput!
    $context: RequestContextInput!
  ) {
    deleteParameterItem(input: $id, context: $context) {
      id
      groupId
    }
  }
`;

export const GET_FILE_CONTENT_QUERY = gql`
  query getFileContent($id: ThirdLevelIDInput!, $context: RequestContextInput!) {
    getFileContent(id: $id, context: $context) {
      content      
    }
  }
`;

export const UPDATE_FILE_CONTENT_MUTATION = gql`
  mutation updateFileContent(
    $input: UpdateFileContentInput!
    $condition: ThirdLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateFileContent(
      input: $input
      condition: $condition
      context: $context
    ) {
      content
    }
  }
`;


export const PUBLISH_PRODUCT_MUTATION = gql`
  mutation publishProduct(
    $input: PublishProductInput!
    $context: RequestContextInput!
  ) {
    publishProduct(input: $input, context: $context) {
      id
    }
  }
`;

export const UNPUBLISH_PRODUCT_MUTATION = gql`
  mutation unpublishProduct(
    $input: UnPublishProductInput!
    $context: RequestContextInput!
  ) {
    unpublishProduct(input: $input, context: $context) {
      id
    }
  }
`;

export const GET_PRODUCTS_BY_FILTER_QUERY = gql`
  query getProductsListByFilter(
    $filter: ProductFilterInput
    $from: Int
    $size: Int
    $context: RequestContextInput!
  ) {
    listProducts(
      filter: $filter
      from: $from
      size: $size
      context: $context
    ) {
      items {
        id
        createdBy
        createdAt
        updatedAt
        updatedBy
        description
        title
        thumbnailImageUrl
        thumbnailImage
        solver
        price
      }
      total
    }
  }
`;